import { render, staticRenderFns } from "./AppDataLoader.vue?vue&type=template&id=79e08c34&scoped=true"
import script from "./AppDataLoader.vue?vue&type=script&lang=js"
export * from "./AppDataLoader.vue?vue&type=script&lang=js"
import style0 from "./AppDataLoader.vue?vue&type=style&index=0&id=79e08c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e08c34",
  null
  
)

export default component.exports